import $ from "jquery";
import moment from "moment-timezone";

async function init(e) {
  const station = $(e).data("station-id");
  const duration = $(e).data("duration");

  const apiUrl =
    "https://public-api.berthr.com/public/api/v1/sites/" +
    station +
    "/weather/tides?duration=" +
    duration;

  moment.tz.setDefault("Europe/London");
  const isBST = moment().isDST();

  $("#tidal-time").html(isBST === true ? "Time (BST)" : "Time (GMT)");

  function drawTides(data) {
    let date;
    let highLow;
    let time;
    let height;

    if (duration > 1) {
      let newCol;

      const cols = data.reduce((r, a) => {
        r[a.date] = [...(r[a.date] || []), a];
        return r;
      }, {});

      for (const col in cols) {
        if (Object.prototype.hasOwnProperty.call(cols, col)) {
          date = moment(col).format("ddd Do");

          if (moment(col).isSame(moment(), "day") === true) {
            date = "Today";
          }

          if (moment(col).isSame(moment().add(1, "day"), "day") === true) {
            date = "Tomorrow";
          }

          newCol =
            "<div class=\"tidal-widget__column\"><div class=\"tidal-widget__date\"><strong>" +
            date +
            "</strong></div>";

          for (const row of cols[col]) {
            if (isBST === true) {
              time = moment(row.dateTime)
                .add(1, "hour")
                .format("HH:mm");
            } else {
              time = moment(row.dateTime).format("HH:mm");
            }
            highLow = row.eventType === "HighWater" ? "H" : "L";
            height = parseFloat(row.height).toFixed(1) + "m";

            newCol +=
              "<div class=\"tidal-widget__tide\"><strong>" +
              time +
              "</strong><span>" +
              highLow +
              height +
              "</span></div>";
          }

          newCol += "</div>";

          $("#tidal-widget").append(newCol);
        }
      }
    } else {
      let newRow;

      for (const row of data) {
        highLow = row.eventType === "HighWater" ? "High" : "Low";
        height = parseFloat(row.height).toFixed(1);

        if (isBST === true) {
          time = moment(row.dateTime)
            .add(1, "hour")
            .format("HH:mm");
        } else {
          time = moment(row.dateTime).format("HH:mm");
        }

        newRow =
          "<tr><td>" +
          highLow +
          "</td><td>" +
          time +
          "</td><td>" +
          height +
          "</td></tr>";

        $("#tidal-widget tbody").append(newRow);
      }
    }

    $("#tidal-widget").show();
  }

  if (station) {
    $.ajax({
      url: apiUrl
    }).done(data => {
      drawTides(data);
    });
  }
}

export default { init };
